import { useState } from "react";
import { Alert } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { useCreateRouteMutation } from "../../../../../api/jeep-rally/routes/routes.hooks";
import { isJeepRallyAdmin } from "../../Categories/utils/category.utils";
import RouteForm from "../_components/RouteForm";
import {
  buildRouteCreatePayload,
  getRouteApiErrorMessage,
  initialRouteForm,
  validateRouteForm,
} from "../utils/route.utils";

const RouteCreatePage = () => {
  const history = useHistory();
  const canManage = isJeepRallyAdmin();

  const [form, setForm] = useState(initialRouteForm);
  const [validationErrors, setValidationErrors] = useState({});

  const {
    mutate: createRoute,
    isLoading,
    isPending,
    error,
    reset,
  } = useCreateRouteMutation();

  const submitting = isLoading || isPending;

  const updateField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setValidationErrors((prev) => ({ ...prev, [key]: undefined }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canManage) return;

    reset();

    const nextErrors = validateRouteForm(form);
    setValidationErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    createRoute(buildRouteCreatePayload(form), {
      onSuccess: () => {
        history.push("/jeep-rally/routes");
      },
    });
  };

  const goBack = () => history.push("/jeep-rally/routes");

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to routes list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <h4 className="card-title mb-0">Create Route</h4>
          </div>
        </div>

        <div className="card-body">
          <p className="text-muted mb-4">
            Create a route with optional stages and track map image. Stages can
            include starting and ending points.
          </p>

          {!canManage && (
            <Alert variant="warning" className="mb-4">
              Admin access is required to create routes.
            </Alert>
          )}

          {error && (
            <Alert variant="danger" className="mb-4">
              {getRouteApiErrorMessage(
                error,
                "Failed to create route. Please try again."
              )}
            </Alert>
          )}

          <RouteForm
            form={form}
            validationErrors={validationErrors}
            submitting={submitting}
            submitLabel="Create Route"
            submittingLabel="Creating..."
            readOnly={!canManage}
            onSubmit={handleSubmit}
            onFieldChange={updateField}
            onBack={goBack}
          />
        </div>
      </div>
    </div>
  );
};

export default RouteCreatePage;
